import { Controller } from 'stimulus';
import Rails, { handleDisabledElement } from "@rails/ujs";

export default class LocalizationController extends Controller {
  static targets = ["defaultValue", "translatedValue", "content", "inputContainer"]

  update_translated_value() {
    event.preventDefault()
    let localization_id = this.translatedValueTarget.getAttribute("data-localization-id")
    let translated_value = this.translatedValueTarget.value

    let data = { "localization": { "translated_value": translated_value } }
    let self = this
    fetch(`/localizations/${localization_id}`, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        'X-CSRF-Token': Rails.csrfToken()
      },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(function (response) {
        self.contentTarget.innerText = response.translated_value
        LocalizationController.#hide(self.inputContainerTarget)
        LocalizationController.#show(self.contentTarget)
        return response
      })
      .catch(error => alert("Translation has not been updated."))
  }

  cancel() {
    LocalizationController.#show(this.contentTarget)
    LocalizationController.#hide(this.inputContainerTarget)
  }

  showInput() {
    LocalizationController.#show(this.inputContainerTarget)
    this.translatedValueTarget.focus()
    LocalizationController.#hide(this.contentTarget)

    if (this.contentTarget.innerText === "[Update me]") {
      // if there is no value yet, initialize with default value
      this.translatedValueTarget.value = this.defaultValueTarget.innerText
    }
  }

  static #hide(element) {
    element.style.display = "none"
  }

  static #show(element) {
    element.style.display = "block"
  }
}
